import { skipToken } from '@reduxjs/toolkit/query';
import WorkspaceInheritanceAPI from '../WorkspaceInheritance/WorkspaceInheritanceAPI';
import useMyWorkspace from './useMyWorkspace';

function useMyWorkspacesChildren() {
  const { data: workspace } = useMyWorkspace();
  return WorkspaceInheritanceAPI.useGetChildrenQuery(
    workspace?.id ?? skipToken
  );
}

export default useMyWorkspacesChildren;
